'use strict';

export default class Validation {

    constructor(rules) {
        this.rules = rules
        this.addMethod()
    }

    validator = function () {
        const rules = this.rules

        $("form").each(function() {
            $(this).validate({
                lang: 'id',
                ignore: null,
                onfocusout: function(element) {
                    this.element(element)
                },
                onkeyup: function(element) {
                    $(element).valid()
                },
                errorElement: "div",
                errorClass : 'fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback',
                wrapper: 'div',
                errorPlacement: function (error, element) {
                    if (element.parent('.input-group').length) {
                        error.insertAfter(element.parent())
                    } 
                    else if (element.parent('.input-icon').length) {
                        error.insertAfter(element.parent())
                    }
                    else if (element.hasClass('form-select')) {
                        error.insertAfter(element.next('span'))
                    }
                    else if (element.attr("type") == "radio") {
                        error.insertAfter(element.closest('div.radio-inline'))
                    }
                    else if (element.attr("type") == "checkbox") {
                        error.insertAfter(element.closest('div.form-check'))
                    }
                    else if (element.attr("type") == "file") {
                        //error.insertAfter(element.closest('div.input-image'));
                        error.insertAfter(element.closest('div.image-input'))
                    }
                    else {
                        error.insertAfter(element);
                    }
                },
                highlight: function (element) {
                    $(element).closest('.form-control').addClass('is-invalid')
                    if ($(element).hasClass('form-select')) {
                        $(element).closest('.fv-row').addClass('is-invalid')
                    }
                },
                unhighlight: function(element) {
                    $(element).closest('.form-control').removeClass('is-invalid')
                    if ($(element).hasClass('form-select')) {
                        $(element).closest('.fv-row').removeClass('is-invalid')
                    }
                },
                success: function (element) {
                    $(element).closest('.form-control').removeClass('is-invalid')
                },
                focusInvalid: true,
                invalidHandler: function (form, validator) {
                    if (!validator.numberOfInvalids())
                        return
    
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element).offset().top
                    }, 500)
                },
                rules: rules.rules,
                messages: rules.messages
            })
        })
    }

    addMethod = function () {
        $.validator.addMethod('password_check', function(value) {
            return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,32}$/.test(value);
        }, 'Kata sandi minimal harus terdiri dari 8 karakter, maksimal 32 karakter yang berisi minimal satu huruf kecil, satu huruf besar, satu digit angka, dan satu karakter khusus.')

		$.validator.addMethod("greaterThan", 
			function(value, element, params) {
				if (!/Invalid|NaN/.test(new Date(value))) {
					return new Date(value) >= new Date($(params).val())
				}
				return isNaN(value) && isNaN($(params).val()) 
					|| (Number(value) >= Number($(params).val()))
			},'Nilai harus lebih besar dari {0}.')

        $.validator.addMethod("gt",
            function (value, element, param) {
                if(param.length > 0) {
                    const $otherElement = $(param[0]),
                        a = Number(value.toString().replace(/,/g, "-")),
                        b = Number($otherElement.val().toString().replace(/,/g, ''))

                    return a > b
                }
                return true
            }, 'Jumlah harus lebih > dari {1}.'
        );
        
        $.validator.addMethod("lt",
            function(value, element, param) {
                if(param.length > 0) {
                    var i = Number(value.toString().replace(/,/g, ''))
                    var j = Number($(param[0]).val().toString().replace(/,/g, ''))
                    return (i < j) ? true : false
                }
                return true
            }, '{1}.'
        )

		$.validator.addMethod('filesize', function(value, element, param) {
            param = param * 1024;
            return this.optional(element) || (element.files[0].size <= param)
        }, 'Ukuran file harus kurang dari {0} Kb')

		$.validator.addMethod('fixDimension', function(value, element, param) {
            if (element.files.length == 0)  return true

            var width = $(element).data('imageWidth')
            var height = $(element).data('imageHeight')
			if(typeof param[2] === 'undefined' || param[2] === null ) {
				if (width == param[0] && height == param[1]) {
					return true
				}
				return false
			} else {
				if (width <= param[0] && height <= param[1]) {
					return true
				}
				return false
			}
        }, 'Harap unggah gambar dengan dimensi {0} x {1} piksel.')

        $.validator.addMethod('dimension', function(value, element, param) {
            if (element.files.length == 0) return true

            var width = $(element).data('imageWidth')
            var height = $(element).data('imageHeight')
            if (width >= param[0] && height >= param[1]) {
                return true
            } else {
                return false
            }
        }, 'Harap unggah gambar dengan dimensi {0} x {1} piksel.')

		$.validator.addMethod("notOnlyZero", function (value, element, param) {
            return this.optional(element) || parseInt(value) > 0
        }, 'Nilai harus lebih besar dari 0 ')

        $.validator.addMethod('money', function(value, element, param) {
            value = Number(value.toString().replace(/\Rp\s?|(,*)/g, ''))
            return $.isNumeric(value)
        }, 'Format mata uang tidak sesuai')

        $.validator.addMethod('percentage', function(value, element, param) {
            value = Number(value.toString().replace(/\%\s?|(,*)/g, ''))
            return $.isNumeric(value) && value <= 100
        }, 'Format persentase tidak sesuai')

        $.validator.addMethod("youtube", function(value, element) {
            if(!value) return true
            var p = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/
            return (value.match(p)) ? RegExp.$1 : false
           }, "Harap masukan youtube url yang benar.")
		
		$.each($.validator.methods, function(key, value) {
            $.validator.methods[key] = function() {
                if (arguments.length > 0) {
                    arguments[0] = $.trim(arguments[0])
                }
    
                return value.apply(this, arguments)
            }
        })
    }
}
